export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  TouchScroll,
} from './touchScroll';
